import { useEffect, useState } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { ArrowDown, ArrowUp, ChevronLeft } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import PermissionDenied from '../common/permissionDenied';
import { useGetSubAdmin } from './api/index';
import { useParams, Link } from 'react-router-dom';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import { WaitingLoader } from '../../hooks/buttonLoad';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';


function SubAdminHistory() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const { id } = useParams();

    const [sortOrder, setSortOrder] = useState("desc")
    const searchText = useDebounce("");
    const { data: getLoginHistory, isLoading } = useGetSubAdmin({
        page: tempPage,
        id: id,
        size: tempRows,
        searchText,
        sortField: "_id",
        sortOrder: sortOrder
    })

    const totalRecords = getLoginHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);


    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
    }, []);


    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'SubAdminHistory' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const renderLoginHistoryTable = () => (
        getLoginHistory?.data?.subLoginHistory?.length > 0 ?
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ maxWidth: "60px" }} align='center'>
                                        S.NO
                                    </TableCell>
                                    <TableCell align="center">IP ADDRESS</TableCell>
                                    <TableCell align="center">BROWSER</TableCell>
                                    <TableCell align="center">OS</TableCell>
                                    <TableCell align="center">EMAIL</TableCell>
                                    <TableCell align="center">Date and Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder('desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getLoginHistory?.data?.subLoginHistory?.map((row, i) => (
                                    <TableRow key={row.id || i}>
                                        <TableCell align='center'>{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row.ip}</TableCell>
                                        <TableCell align="center">{row.browser}</TableCell>
                                        <TableCell align="center">{row.device}</TableCell>
                                        <TableCell align="center">{row.admin?.email}</TableCell>
                                        <TableCell align="center">
                                            {moment(row.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
            :
            <NoRecords />
    )

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <section>
                <div className='d-flex flex-wrap justify-content-between'>
                    <h6 className="pb-2 d-flex align-items-center">
                        <Link to="/SubAdmin" className="d-flex align-items-center hover:text-primary">
                            <ChevronLeft size={18} className="me-2" />
                        </Link>
                        Sub Admin Login History
                    </h6>
                </div>
                <div className="ad_pg_bx bg-white p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                    </div>
                    {isLoading ? <PageLoader /> : renderLoginHistoryTable()}
                </div>
            </section>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;
}

export default SubAdminHistory